import { render, staticRenderFns } from "./accountItem.vue?vue&type=template&id=8c8209a8&scoped=true&"
import script from "./accountItem.vue?vue&type=script&lang=js&"
export * from "./accountItem.vue?vue&type=script&lang=js&"
import style0 from "./accountItem.vue?vue&type=style&index=0&id=8c8209a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8209a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c8209a8')) {
      api.createRecord('8c8209a8', component.options)
    } else {
      api.reload('8c8209a8', component.options)
    }
    module.hot.accept("./accountItem.vue?vue&type=template&id=8c8209a8&scoped=true&", function () {
      api.rerender('8c8209a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/start/login/accountItem.vue"
export default component.exports